import { initTomSelect } from './tom-select';
import { initDatepicker } from './datepicker';

function initInputUpdate(parent: HTMLElement | Document): void {
  const inputs = parent.querySelectorAll<HTMLInputElement | HTMLSelectElement>('.js-add-oi-input');
  inputs.forEach((input) => {
    const priceInput = document.querySelector<HTMLInputElement>("input[name='PricePerUnit']");
    const unitWrapper = document.querySelector<HTMLElement>('#unit-wrapper');
    const pricesAttr = input.getAttribute('data-prices');
    const unitsAttr = input.getAttribute('data-units');

    if (!pricesAttr || !unitsAttr || !priceInput || !unitWrapper) return;

    const prices: Record<string, number> = JSON.parse(pricesAttr);
    const units: Record<string, string> = JSON.parse(unitsAttr);

    input.addEventListener('change', function () {
      const value = input.value;
      priceInput.value = String(prices[parseInt(value)] ?? 0);
      unitWrapper.innerHTML = units[parseInt(value)] ?? '';

      const productUnitInput = parent.querySelector<HTMLInputElement>("input[name='ProductUnit']");
      if (productUnitInput) {
        productUnitInput.value = units[parseInt(value)];
      }
    });
  });
}

function initConditionalDisplay(parent: HTMLElement | Document): void {
  const conditionalDisplayDivs = parent.querySelectorAll<HTMLElement>('.js-conditional-display');

  conditionalDisplayDivs.forEach((div) => {
    const targetFieldName = div.getAttribute('data-field');
    const targetFieldValue = div.getAttribute('data-value');

    const form = div.closest('form');
    if (!form || !targetFieldName) return;

    const targetInput = form.querySelector<HTMLInputElement | HTMLSelectElement>(
      `#${targetFieldName}`
    );
    if (!targetInput) return;

    // Checkboxes keep a constant `value`, so their state has to be read from `checked`.
    const isCheckbox = targetInput instanceof HTMLInputElement && targetInput.type === 'checkbox';

    // Function to check input value and display/hide the div
    function checkDisplayCondition() {
      const currentValue = isCheckbox
        ? String((targetInput as HTMLInputElement).checked)
        : targetInput.value;

      if (currentValue === targetFieldValue) {
        div.style.display = 'block';
      } else {
        div.style.display = 'none';
      }
    }

    // Initial check and event listener
    checkDisplayCondition();
    targetInput.addEventListener('input', checkDisplayCondition);
    targetInput.addEventListener('change', checkDisplayCondition);
  });
}

export function initForms(parent: HTMLElement | Document): void {
  initInputUpdate(parent);
  initTomSelect(parent);
  initDatepicker(parent);
  initConditionalDisplay(parent);
}
